const metadataTemplateTypes = {
	ONIX: "onixTemplate",
	EXCEL: "excelTemplate",
	CUSTOM_XML: "customXmlTemplate",
	JSON: "jsonTemplate",
};

export default metadataTemplateTypes;
